class Constants {
    static BaseUrl =  "http://faraadapi.faraad.org/api/";
    // static BaseUrl =  "http://far.test/api/";
    static Admin = "supremeAdminFaraad";

}

export default Constants;